import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { ColorModeProvider } from './colorMode';
import { company, pageTitles } from './content/site';
import HeaderNav from './components/HeaderNav/HeaderNav';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Services from './pages/Services/Services';
import Approach from './pages/Approach/Approach';
import ContactUs from './pages/ContactUs/ContactUs';
import About from './pages/About/About';
import NoPage404 from './pages/NoPage404/NoPage404';
import './App.scss';

const DocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = pageTitles[location.pathname] ?? `Page not found — ${company.name}`;
  }, [location.pathname]);

  return null;
};

/** Keeps hash targets and new pages from opening mid-scroll under the sticky header. */
const ScrollToPlace = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        element.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export const AppShell = () => {
  return (
    <ColorModeProvider>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
        <Box
          component="a"
          href="#main"
          sx={{
            position: 'absolute',
            left: 8,
            top: -48,
            zIndex: 2000,
            bgcolor: 'background.paper',
            color: 'text.primary',
            px: 2,
            py: 1,
            borderRadius: 1,
            '&:focus': { top: 8 },
          }}
        >
          Skip to content
        </Box>
        <DocumentTitle />
        <ScrollToPlace />
        <HeaderNav />
        <Box component="main" id="main" tabIndex={-1} sx={{ flex: 1, outline: 'none' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="*" element={<NoPage404 />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </ColorModeProvider>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
};

export default App;
